import { motion } from "framer-motion";
import { EASE } from "./Reveal";

export default function Preloader({ onDone }) {
  return (
    <motion.div
      data-testid="preloader"
      className="fixed inset-0 z-[100] bg-ivory flex flex-col items-center justify-center"
      exit={{ y: "-100%" }}
      transition={{ duration: 1, ease: EASE }}
      onAnimationComplete={onDone}
    >
      <div className="overflow-hidden">
        <motion.img
          src="/images/logo-vivore-black.png"
          alt="vivoré"
          className="h-14 md:h-20 w-auto"
          initial={{ y: "120%" }}
          animate={{ y: 0 }}
          transition={{ duration: 1, delay: 0.2, ease: EASE }}
        />
      </div>
      <motion.div
        className="mt-8 h-px bg-ink/60 origin-left"
        initial={{ scaleX: 0 }}
        animate={{ scaleX: 1 }}
        transition={{ duration: 1.5, delay: 0.3, ease: EASE }}
        style={{ width: "min(240px, 40vw)" }}
      />
      <motion.p
        className="eyebrow mt-4"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ delay: 0.8, duration: 0.8 }}
      >
        Luxe Beauty, Timeless Grace
      </motion.p>
    </motion.div>
  );
}
